<template>
    <div>
        <div class="md:flex space-y-3 md:space-y-0 md:space-x-3 mt-4">
            <select v-model="filtrKemp" @change="zmenaFiltr" class="form-select form-control w-full md:w-1/4">
                <option value="">Kemp</option>
                <option v-for="kemp in kempy" :key="kemp.id_kempy" :value="kemp.id_kempy">{{ kemp.nazev }}</option>
            </select>

            <select v-model="filtrTyp" @change="zmenaFiltr" class="form-select form-control w-full md:w-1/4">
                <option value="">Typ</option>
                <option value="api">API</option>
                <option value="gopay">GoPay</option>
                <option value="mail">Email</option>
                <option value="cnb">ČNB</option>
            </select>

            <input v-model="filtrObjednavka" @change="zmenaFiltr" type="text" placeholder="ID objednávky" class="form-input form-control w-full md:w-1/4">

            <select v-model="filtrChyba" @change="zmenaFiltr" class="form-select form-control w-full md:w-1/4">
                <option value="">Výsledek</option>
                <option v-for="chyba in chyby" :key="chyba" :value="chyba ? chyba : 'null'">{{ chyba ? chyba : 'OK' }}</option>
            </select>
        </div>

        <div class="mt-6 divide-y divide-gray-100 rounded shadow overflow-hidden">
            <div v-for="udalost in udalosti" :key="udalost.id" class="flex items-start md:items-center justify-between md:h-16 px-4 md:px-8 py-4 md:py-0 md:space-x-6 bg-white hover:bg-gray-50 duration-300">
                <div class="flex-1 md:flex items-center min-w-0">
                    <div class="flex-none md:w-40">
                        <div class="text-15 truncate">{{ udalost.created_at_format }}</div>
                        <div class="text-13 text-gray-400 truncate">{{ udalost.kemp.nazev }}</div>
                    </div>

                    <div class="flex-1 flex items-center min-w-0 md:ml-6 mt-3 md:mt-0">
                        <div class="flex-none w-22">
                            <div v-if="udalost.typ == 'api'" class="inline-flex px-3 py-1 text-13 text-center bg-light-100 rounded-full">
                                <svg class="text-light-400 w-4.5 h-4.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                </svg>
                                <div class="ml-1.5 text-light-800">API</div>
                            </div>

                            <div v-else-if="udalost.typ == 'gopay'" class="inline-flex px-3 py-1 text-13 text-center bg-indigo-100 rounded-full">
                                <svg class="text-indigo-400 w-4.5 h-4.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                                </svg>
                                <div class="ml-1.5 text-indigo-800">GoPay</div>
                            </div>

                            <div v-else-if="udalost.typ == 'mail'" class="inline-flex px-3 py-1 text-13 text-center bg-purple-100 rounded-full">
                                <svg class="text-purple-400 w-4.5 h-4.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                                </svg>
                                <div class="ml-1.5 text-purple-800">Email</div>
                            </div>

                            <div v-else-if="udalost.typ == 'cnb'" class="inline-flex px-3 py-1 text-13 text-center bg-cyan-100 rounded-full">
                                <svg class="text-cyan-400 w-4.5 h-4.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" />
                                </svg>
                                <div class="ml-1.5 text-cyan-800">ČNB</div>
                            </div>
                        </div>

                        <div class="flex-1 ml-2 md:ml-4 -mt-0.5 text-15 truncate">{{ udalost.nazev }}</div>
                    </div>

                    <div class="flex-none md:w-1/4 md:ml-6">
                        <div v-if="udalost.chyba" class="inline-flex items-center px-3 py-1 mt-3 md:mt-0 text-13 bg-red-100 rounded-full">
                            <svg class="text-red-400 w-4.5 h-4.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                            </svg>
                            <div class="ml-1.5 text-red-800 truncate">{{ udalost.chyba }}</div>
                        </div>
                        <div v-else class="hidden md:inline-flex items-center px-3 py-1 mt-3 md:mt-0">
                            <svg class="text-green-400 w-4.5 h-4.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                            </svg>
                        </div>
                    </div>
                </div>

                <div class="flex-none">
                    <a class="block p-1 md:p-2 -mr-1 md:-mr-2 text-gray-300 hover:text-gray-400 duration-300" :href="'/admin/udalosti/' + udalost.id">
                        <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                    </a>
                </div>
            </div>
        </div>

        <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
            <div slot="no-more"></div>

            <div slot="no-results">
                <p class="mt-4 text-left">Nebyl nalezen žádný záznam</p>
            </div>
        </infinite-loading>
    </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';

export default {
    components: {
        InfiniteLoading,
    },

    props: {
        kempy: Array,
        chyby: Array,
        kempInit: String,
        typInit: String,
        objednavkaInit: String,
        chybaInit: String,
    },

    data: function () {
        return {
            udalosti: [],
            page: 1,
            filtrTyp: this.typInit,
            filtrKemp: this.kempInit,
            filtrObjednavka: this.objednavkaInit,
            filtrChyba: this.chybaInit,
            infiniteId: +new Date(),
        }
    },

    methods: {
        infiniteHandler($state) {
            axios.get('/admin/udalosti/fetch', {
                params: {
                    page: this.page,
                    kemp: this.filtrKemp,
                    typ: this.filtrTyp,
                    objednavka: this.filtrObjednavka,
                    chyba: this.filtrChyba,
                },
            }).then(response => {
                const data = response.data;

                if (data.length) {
                    this.page += 1;
                    this.udalosti.push(...data);
                    $state.loaded();
                } else {
                    $state.complete();
                }
            });
        },

        zmenaFiltr() {
            this.page = 1;
            this.udalosti = [];
            this.infiniteId += 1;
        },
    },
}
</script>
